module.exports = __webpack_public_path__ + "img/fb.f5d65d7f.svg";